// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconQrCode = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M3 3v6h6v2h2v2H9v2H3v6h6v-6h2v-2h2v-2h2V9h6V3h-6v6h-2v2h-2V9H9V3zm4 2H5v2h2zm0 12H5v2h2zM17 5h2v2h-2z"
    />,
    <path d="M14 19v-4h-2v4zm0 0h2v2h-2zm4 0h1v2h2v-4h-3zm3-6h-6v2h6z" />
  );
export default SvgIconQrCode;
